import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { BillingTransactionFilterType } from "@/types/billing-transactions";
import { useTranslation } from "react-i18next";

const BillingTransactionTypeField = ({
  value,
  onChange,
  label,
  error,
  withLabel = true,
  triggerClassName,
}: {
  value?: BillingTransactionFilterType | "all types";
  onChange: (value: string) => void;
  label?: string;
  error?: string;
  withLabel?: boolean;
  triggerClassName?: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className="min-w-0">
      {withLabel && (
        <label className="text-sm font-medium text-gray-700 mb-1">
          {label || t("billing.transactionType")}
        </label>
      )}

      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          className={`w-full flex justify-between border-2 focus:ring-0 focus:border-black hover:border-black ${triggerClassName ?? ""} ${
            error ? "border-red-500" : "border-black"
          }`}
        >
          <SelectValue placeholder={t("billing.chooseType")} />
        </SelectTrigger>

        <SelectContent>
          <SelectItem value="all types">{t("billing.allTypes")}</SelectItem>
          <SelectItem value={BillingTransactionFilterType.PAYMENT}>
            {t("billing.payment")}
          </SelectItem>
          <SelectItem value={BillingTransactionFilterType.REFUND}>
            {t("billing.refund")}
          </SelectItem>
          <SelectItem value={BillingTransactionFilterType.PARTIAL_REFUND}>
            {t("billing.partialRefund")}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default BillingTransactionTypeField;
